<div
  style="
    background: linear-gradient(
      180deg,
      var(--palette-primary-100) 22.4%,
      var(--palette-other-body) 100%
    );
  "
>
  <div class="account-container">
    <div class="flex payment">
      <span class="iconContainer"><img src="/assets/images/IconSuccess.svg" class="icon" /></span>
      <span
        data-cy="confirmationHeading"
        class="confirmationHeading"
        dsContent
        [contentPath]="'billing.recurring.confirmationHeading'"
      ></span>
      <span
        data-cy="confirmationSubHeading"
        class="confirmationSubHeading"
        dsContent
        [contentPath]="'billing.recurring.confirmationSubHeading'"
      ></span>
      <div class="ctaContainer card">
        <ds-payment-details
          style="width: 100%"
          [data]="data"
          [riskDescription]="riskDescription"
          [isConfirmationPage]="true"
          [isRecurringPage]="true"
          [showActionLink]="true"
        />
      </div>
      <div class="ctaContainer">
        <call-to-action
          [fullWidthButtons]="true"
          [primaryButtonName]="primaryButtonName"
          (primaryEvent)="close()"
          style="width: 100%"
          [noMargin]="true"
        ></call-to-action>
      </div>
      <amfam-confetti />
    </div>
  </div>
</div>
